import React from 'react';
import { Quote } from 'lucide-react';
import { Card } from './ui/Card';
export function Testimonials() {
  const testimonials = [{
    name: 'Laura G.',
    role: 'Docente de Primaria',
    text: '¡Increíble material! Me salvó el año. Las dinámicas son súper divertidas y a los chicos les encantan. Lo recomiendo totalmente.',
    initial: 'L'
  }, {
    name: 'Martín R.',
    role: 'Profesor de Teatro',
    text: 'La sección de secundaria es muy completa. Los proyectos de montaje están muy bien estructurados paso a paso. Excelente inversión.',
    initial: 'M'
  }, {
    name: 'Sofía P.',
    role: 'Tallerista Independiente',
    text: 'Uso los bonos todo el tiempo. El banco de dinámicas es inagotable. Me permite variar mis clases y mantener el interés siempre alto.',
    initial: 'S'
  }];
  return <section className="py-20 bg-gray-900 text-white relative overflow-hidden" data-id="element-147">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-148">
        <div className="absolute top-10 left-10 w-64 h-64 bg-red-600 rounded-full blur-3xl" data-id="element-149"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-amber-500 rounded-full blur-3xl" data-id="element-150"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-151">
        <div className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-153">
            Lo que dicen los <span className="text-amber-400" data-id="element-154">Docentes</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-155">
            Colegas que ya transformaron sus clases con el Mega Pack.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-156">
          {testimonials.map((t, i) => <Card key={i} className="bg-gray-800 border-gray-700 p-8 relative" data-id="element-157">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-600 opacity-50" data-id="element-158" />
              <div className="flex items-center gap-4 mb-6" data-id="element-159">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-amber-500 flex items-center justify-center text-xl font-bold text-white" data-id="element-160">
                  {t.initial}
                </div>
                <div data-id="element-161">
                  <h4 className="font-bold text-white" data-id="element-162">{t.name}</h4>
                  <p className="text-sm text-gray-400" data-id="element-163">{t.role}</p>
                </div>
              </div>
              <p className="text-gray-300 italic leading-relaxed" data-id="element-164">"{t.text}"</p>
            </Card>)}
        </div>
      </div>
    </section>;
}